<template>
  <div id="manageClass">
    <div class="Secondary">
      <nb-tags ref="tags" v-on:child-data="getChildData"></nb-tags>
    </div>
    <div class="allBodyDiv" message="chaildMsg">
      <div style="margin-top: 15px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row>
        <div class="manageClassHeader">
          <div style="padding: 0 30px">
            <el-row>
              <el-col :span="24" style="line-height: 33px; display: flex; align-items: center;">
                <span
                  v-if="changeClass"
                  style="font-size: 24px; margin-right: 24px;"
                  @click="clickClassName"
                >
                  {{ classInfo.classname }}
                  <i>
                    <img src="/static/images/exam/pen_icon.png" alt />
                  </i>
                </span>

                <span v-else style="font-size: 24px">
                  <el-input
                    id="classNameInput"
                    @blur="changeClassName"
                    @keydown.enter.native="keyClassName"
                    style="width: 174px"
                    v-model="classInfo.classname"
                  ></el-input>
                  <i>
                    <img src="/static/images/exam/pen_icon.png" alt />
                  </i>
                </span>

                <el-tag
                  type="warning"
                  style="color: #ff800e; background-color: #ffdec0; border-radius: 10px; height: 24px; line-height: 24px; min-width: 98px;"
                  >编号：{{ classInfo.class_code }}</el-tag
                >
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <span @click="classDismiss = true">解散班级</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <div style="float: right; margin-right: 70%">
                </div> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="margin-top: 0">
                <span style="font-size: 14px"
                  >创建时间：{{ classInfo.addtime }}</span
                >
                <el-button size="mini" @click="joinGuide = true" class="nbTag"
                  >加入班级指南</el-button
                >
              </el-col>
            </el-row>
            <!--<el-button id="release" @click="releaseBtn" type="primary">发布考试</el-button>-->
          </div>
        </div>
      </el-row>

      <el-row class="manageClassBody" :gutter="20">
        <el-col style="width: 298px" :span="5" class="leftMember">
          <el-card class="box-card" id="memberCard" style="max-height: 1389px">
            <div slot="header" class="clearfix">
              <i class="blueI" style="left: 10px"></i>
              <span class="cardHeader">班级成员（{{ studentNumber }}人）</span>
              <el-button
                size="mini"
                @click="
                  $router.push({
                    path: '/classmember',
                    query: { plan: classId },
                  })
                "
                class="nbBtn"
                >管理</el-button
              >
            </div>
            <div style="padding-bottom: 15px;">
              <el-table
                id="memberTable"
                :data="studentList"
                stripe
                style="width: 100%"
              >
                <el-table-column label>
                  <template slot-scope="props">
                    <div
                      style="height: 50px; line-height: 50px; cursor: pointer"
                      @click="
                        $router.push({
                          path: '/memberdetails',
                          query: {
                            plan: props.row.userId,
                            classId: classId,
                            name: props.row.nickname,
                            path: 1,
                          },
                        })
                      "
                    >
                      {{ props.row.nickname }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="80" label>
                  <template slot-scope="props">
                    <el-button
                      @click="editNote(props.row.id)"
                      type="text"
                      size="small"
                      style="color: #7d7d7d"
                    >
                      <span
                        style="
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                        v-if="props.row.markName"
                        :title="props.row.markName"
                        >{{ props.row.markName }}</span
                      >
                      <span v-else>添加备注</span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: #7d7d7d; font-size: 12px; margin-top: 15px">
                *备注名称仅教师可见
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col style="width: 922px" :span="19" class="rightBody">
          <el-row>
            <el-card class="box-card" style="position: relative">
              <div slot="header" class="clearfix">
                <i class="blueI"></i>
                <span class="cardHeader">班级分数曲线</span>
                <el-select
                  @change="getChildData(classId, '', -2)"
                  v-model="selectValue"
                  placeholder="请选择"
                  class="classSelect"
                  style="width: 300px"
                >
                  <el-option
                    v-for="i in testList"
                    :key="i.name"
                    :label="i.name"
                    :value="i.id"
                  ></el-option>
                </el-select>

                <el-date-picker
                  class="fr nbTimePacker"
                  style="margin-right: 35px; width: 240px; padding-right: 0px"
                  @change="getChildData(classId)"
                  v-model="timeValue"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div>
                <ve-line
                  id="canvas"
                  :data="chartData"
                  :settings="chartSettings"
                ></ve-line>
              </div>
            </el-card>
          </el-row>

          <el-row class="manageClassBody" :gutter="20">
            <!-- 正在进行 -->
            <el-col :span="24" class="leftMember">
              <el-card class="box-card listCard2">
                <div
                  slot="header"
                  class="clearfix"
                  style="height: 34px; line-height: 34px"
                >
                  <i class="blueI" style="left: 11px !important"></i>
                  <span
                    style="
                      font-size: 18px;
                      font-family: PingFangSC-Medium;
                      font-weight: 500;
                      color: rgba(51, 51, 51, 1);
                    "
                    >正在进行</span
                  >
                </div>
                <div v-for="i in tableData3">
                  <div class="testReleaseList">
                    <div
                      class="listHeader"
                      style="
                        position: relative;
                        height: 75px;
                        line-height: 25px;
                      "
                    >
                      <span
                        style="width: 215px; display: inline-block"
                        class="listHeader-title"
                        >{{ i.group_name }}</span
                      >
                      <el-button
                        style="cursor: default"
                        class="listHeader-btn"
                        type="primary"
                        size="mini"
                        >{{ i.classname }}</el-button
                      >

                      <span
                        class="listHeader-time"
                        style="position: relative; top: 15px"
                        >开始时间：{{ i.start_time }}<br />结束时间：{{
                          i.end_time
                        }}</span
                      >

                      <span
                        class="listHeader-overTime"
                        style="margin-left: 35px"
                        >距离结束：{{ i.endTime }}</span
                      >
                      <el-button
                        @click="relectUpdo(i.group_id, i.class_id)"
                        style="
                          margin-left: 20px;
                          width: 110px;
                          height: 24px;
                          background: rgba(255, 222, 192, 1);
                          border-radius: 12px;
                          color: #ff800e;
                          display: none;
                        "
                        class="listHeader-btn"
                        type="primary"
                        size="mini"
                        >强制结束</el-button
                      >
                    </div>
                    <div class="listBody">
                      <el-table
                        :show-header="false"
                        :data="i.item"
                        border
                        highlight-current-row
                        row-class-name="graspTr"
                        header-row-class-name="graspHeader"
                        style="width: 100%"
                      >
                        <el-table-column
                          label="实验名"
                          width="355"
                          align="center"
                        >
                          <template slot-scope="props">
                            <span
                              @click="
                                $router.push({
                                  path: '/testdetails',
                                  query: {
                                    plan: props.row.examination_id,
                                    title: i.group_name,
                                    name: props.row.name,
                                    relationId: props.row.relation_id,
                                    classId: i.classId,
                                  },
                                })
                              "
                              style="cursor: pointer"
                              >{{ props.row.name }}</span
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          label="操作"
                          width="645"
                          align="center"
                        >
                          <template slot-scope="props">
                            <div style="display: inline-block; width: 200px">
                              <el-progress
                                :percentage="props.row.ratioHalf"
                                status="success"
                                :show-text="false"
                              ></el-progress>
                            </div>
                            <span>{{ props.row.sub_num }}人</span>/
                            <span>共{{ props.row.studentNum }}人</span>
                          </template>
                        </el-table-column>

                        <el-table-column
                          label="详情"
                          width="155"
                          align="center"
                        >
                          <template slot-scope="props">
                            <el-button
                              @click="
                                $router.push({
                                  path: '/testdetails',
                                  query: {
                                    plan: props.row.examination_id,
                                    title: i.group_name,
                                    name: props.row.name,
                                    relationId: props.row.relation_id,
                                    classId: i.classId,
                                  },
                                })
                              "
                              class="listHeader-btn"
                              type="primary"
                              size="mini"
                              >测验详情</el-button
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>

                <div
                  v-if="filters.total > 0"
                  style="margin-top: 30px; text-align: right"
                >
                  <el-pagination
                    @size-change="pageSizeChange(2)"
                    @current-change="pageChange"
                    :current-page="currentPage4"
                    :page-sizes="[2]"
                    :page-size="filters.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="filters.total"
                    style="display: none"
                  ></el-pagination>
                </div>
              </el-card>
            </el-col>
            <!-- 已结束 -->
            <el-col :span="24" class="leftMember">
              <el-card class="box-card listCard2">
                <div
                  slot="header"
                  class="clearfix"
                  style="height: 34px; line-height: 34px"
                >
                  <i class="blueI" style="left: 11px !important"></i>
                  <span
                    style="
                      font-size: 18px;
                      font-family: PingFangSC-Medium;
                      font-weight: 500;
                      color: rgba(51, 51, 51, 1);
                    "
                    >已结束</span
                  >
                </div>
                <div v-for="i in tableData4">
                  <div class="Unpublished">
                    <div class="listHeader">
                      <span
                        style="width: 215px; display: inline-block"
                        class="listHeader-title"
                        >{{ i.group_name }}</span
                      >
                      <el-button
                        style="cursor: default"
                        class="listHeader-btn"
                        type="primary"
                        size="mini"
                        >{{ i.classname }}</el-button
                      >

                      <span class="listHeader-time"
                        >开始时间：{{ i.start_time }}</span
                      >
                      <span class="listHeader-time"
                        >结束时间：{{ i.end_time }}</span
                      >

                      <span class="listHeader-overTime">已结束</span>
                    </div>

                    <div class="listBody">
                      <el-table
                        :show-header="false"
                        :data="i.item"
                        border
                        highlight-current-row
                        row-class-name="graspTr"
                        header-row-class-name="graspHeader"
                        style="width: 100%"
                      >
                        <el-table-column
                          width="355"
                          label="实验名"
                          align="center"
                        >
                          <template slot-scope="props">
                            <span
                              @click="
                                $router.push({
                                  path: '/testdetails',
                                  query: {
                                    plan: props.row.examination_id,
                                    title: i.group_name,
                                    name: props.row.name,
                                    relationId: props.row.relation_id,
                                    classId: i.classId,
                                  },
                                })
                              "
                              style="cursor: pointer"
                              >{{ props.row.name }}</span
                            >
                          </template>
                        </el-table-column>

                        <el-table-column label="操作" align="center">
                          <template slot-scope="props">
                            <div style="display: inline-block; width: 200px">
                              <el-progress
                                :percentage="props.row.ratioHalf"
                                status="success"
                                :show-text="false"
                              ></el-progress>
                            </div>
                            <span>{{ props.row.sub_num }}人</span>/
                            <span>共{{ props.row.studentNum }}人</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="详情"
                          width="155"
                          align="center"
                        >
                          <template slot-scope="props">
                            <el-button
                              @click="
                                $router.push({
                                  path: '/testdetails',
                                  query: {
                                    plan: props.row.examination_id,
                                    title: i.group_name,
                                    name: props.row.name,
                                    relationId: props.row.relation_id,
                                    classId: i.classId,
                                  },
                                })
                              "
                              class="listHeader-btn"
                              type="primary"
                              size="mini"
                              >考试详情</el-button
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>

                <div
                  v-if="filters.total > 0"
                  style="margin-top: 30px; text-align: right"
                >
                  <el-pagination
                    @size-change="pageSizeChange2(2)"
                    @current-change="pageChange2"
                    :current-page="currentPage4"
                    :page-sizes="[2]"
                    :page-size="filters2.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="filters2.total"
                    style="display: none"
                  ></el-pagination>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row style="height: 400px; margin-top: 20px">
            <el-card class="box-card tableCard">
              <div
                slot="header"
                class="clearfix"
                style="height: 34px; line-height: 34px"
              >
                <i class="blueI"></i>
                <span class="cardHeader">实验掌握情况</span>
              </div>
              <div>
                <el-table
                  :data="tableData"
                  height="307"
                  border
                  stripe
                  highlight-current-row
                  row-class-name="graspTr"
                  header-row-class-name="graspHeader"
                  style="width: 100%"
                >
                  <el-table-column prop="name" label="实验名"></el-table-column>
                  <!--<el-table-column prop="num" width="170" label="发布次数"></el-table-column>-->
                  <!--<el-table-column prop="avgScore" width="170" label="最新平均分"></el-table-column>-->
                  <el-table-column width="155" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="
                          $router.push({
                            path: '/examlistdetails',
                            query: {
                              plan: scope.row.relation_id,
                              examId: scope.row.experimentId,
                              type: classId,
                              name: scope.row.name,
                              rId: scope.row,
                            },
                          })
                        "
                        class="nbBtn nbBtn2"
                        size="small"
                        >查看详情</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!--发布实验-->
    <el-dialog
      title
      :show-close="false"
      :visible.sync="releaseTest"
      custom-class="testDialog"
      width="1092px"
    >
      <div>
        <el-card class="box-card" style="position: relative; border: none">
          <div slot="header" class="clearfix">
            <i class="blueI"></i>
            <span class="cardHeader">选择实验</span>
          </div>

          <div class="cardCheck">
            <div id="testCheck">
              <el-checkbox-group
                v-model="releaseForm.checkedTest"
                @change="textNum = releaseForm.checkedTest.length"
              >
                <el-checkbox
                  v-for="i in testList"
                  :key="i.experiment_id"
                  :label="i.experiment_id"
                >
                  <div class="checkDiv">
                    <div :title="i.name" class="checkName">{{ i.name }}</div>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <div class="releaseBody" style="margin-top: 20px">
            <el-form
              :model="releaseForm"
              :rules="rulesRelease"
              ref="releaseForm"
              class="demo-ruleForm"
            >
              <el-form-item
                label="考试名称"
                prop="name"
                label-width="80px"
                style="width: 380px"
              >
                <el-input
                  style="width: 280px"
                  v-model="releaseForm.name"
                  placeholder="实验名称最多十五个字"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="考试时间"
                prop="time"
                label-width="264px"
                style="width: 480px"
              >
                <el-date-picker
                  v-model="releaseForm.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="选择班级"
                prop="checkClass"
                label-width="80px"
                style="width: 100%"
              >
                <el-checkbox-group v-model="releaseForm.checkClass">
                  <el-checkbox
                    v-for="i in classData"
                    :key="i.class_id"
                    v-if="i.class_id == classId"
                    disabled
                    :label="i.class_id"
                    >{{ i.classname }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="releaseTest = false">取 消</el-button>
          <el-button type="primary" @click="nextRelease('releaseForm')"
            >下一步</el-button
          >
        </div>
      </span>
    </el-dialog>

    <!--发布实验2-->
    <el-dialog
      title
      :show-close="false"
      :visible.sync="releaseTest2"
      custom-class="testDialog"
      width="680px"
    >
      <div>
        <el-card class="box-card" style="position: relative; border: none">
          <div slot="header" class="clearfix">
            <i class="blueI"></i>
            <span class="cardHeader">确认信息</span>
          </div>
          <div>
            <el-form
              ref="sureReleaseForm"
              class="demo-ruleForm"
              label-width="90px"
            >
              <el-form-item label="考试名称" prop="name">
                <span>{{ releaseForm.name }}</span>
              </el-form-item>
              <el-form-item label="考试时间" prop="time">
                <span>{{ timeArrray[0] }}</span
                >&nbsp;&nbsp;至&nbsp;&nbsp;
                <span>{{ timeArrray[1] }}</span>
              </el-form-item>
              <el-form-item label="考试班级" prop="checkClass">
                <span>{{ classSelected }}</span>
              </el-form-item>
              <el-form-item label="已选实验" prop="checkClass">
                <div>
                  <span>共选{{ textNum }}实验</span>
                  <el-table
                    :data="releaseArray"
                    :show-header="false"
                    style="width: 100%"
                  >
                    <el-table-column prop="name"></el-table-column>
                    <el-table-column>
                      <template slot-scope="props">
                        <span>设置时长</span>
                        <el-input
                          :maxlength="3"
                          style="width: 40px; height: 40px"
                          class="testTime"
                          v-model="props.row.exam_timelength"
                        ></el-input>
                        <span>分钟</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button
            @click="
              releaseTest = true;
              releaseTest2 = false;
            "
            >上一步</el-button
          >
          <el-button
            type="primary"
            :loading="releaseLoading"
            @click="releaseTestConfirm()"
            >发 布</el-button
          >
        </div>
      </span>
    </el-dialog>

    <!--添加备注-->
    <el-dialog
      title="修改备注"
      :visible.sync="editNoteDialog"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="width: 375px; margin: auto">
        <el-form>
          <el-form-item label="备注名称" prop="name" label-width="80px">
            <el-input
              style="width: 280px"
              v-model="markname"
              placeholder="请输入备注名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="editNoteDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="editNote(-1)"
            :loading="editNoteLoading"
            >确 定</el-button
          >
        </div>
      </span>
    </el-dialog>

    <!--加入班级指南-->
    <el-dialog
      title="添加学生指南"
      :visible.sync="joinGuide"
      custom-class="nbDialog"
      width="500px"
    >
      <div class="joinNum">
        <span>班级编号：</span>
        <span>{{ classInfo.class_code }}</span>
      </div>
      <div class="joinText">
        <div>
          <i>1</i>
          <span
            >将“班级编号：{{
              classInfo.class_code
            }}”写在黑板上或发送给需要加入的学生</span
          >
        </div>
        <div>
          <i>2</i>
          <span
            >让学生使用电脑访问网址并使用给定的帐号密码登录：{{ examUrl }}</span
          >
        </div>
        <div>
          <i>3</i>
          <span
            >让学生点击右上角的“个人中心”按钮，进入后填写班级编号，搜索班级加入</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="joinGuide = false">知道了</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="撤销发布"
      :visible.sync="releaseUndo"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="width: 375px; margin: auto">
        <div style="font-size: 18px; margin-bottom: 15px">
          您确认要撤销发布实验吗？
        </div>
        <span style="font-size: 14px; color: #b5b5b5"
          >实验撤销后，已完成的实验数据也将全部清除且无法找回！</span
        >
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="releaseUndo = false">取 消</el-button>
          <el-button type="primary" @click="undoGroup">确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <!--无学生加入成功-->
    <el-dialog
      title="发布成功"
      :visible.sync="succerTest"
      custom-class="nbDialog"
      width="500px"
    >
      <div v-if="classUserNum">
        <div>
          <span
            style="
              text-align: left;
              font-size: 16px;
              display: inline-block;
              margin-bottom: 15px;
            "
            >您的考试已经发布成功，您可在“班级管理”对应的班级中，看到您发布的考试被完成情况</span
          >
          <span>您可以通过以下方式邀请学生参与您发布的实验考试</span>
        </div>
        <div class="joinNum">
          <span>班级编号：</span>
          <span>{{ classInfo.class_code }}</span>
        </div>
        <div class="joinText">
          <div>
            <i>1</i>
            <span
              >将“班级编号：{{
                classInfo.class_code
              }}”写在黑板上或发送给需要加入的学生</span
            >
          </div>
          <div>
            <i>2</i>
            <span
              >让学生使用电脑访问网址并使用给定的帐号密码登录：{{
                examUrl
              }}</span
            >
          </div>
          <div>
            <i>3</i>
            <span
              >让学生点击右上角的“个人中心”按钮，进入后填写班级编号，搜索班级加入</span
            >
          </div>
        </div>
      </div>
      <div v-else style="width: 300px; margin: auto">
        您的实验已经发布成功，您可在'考试中心'中，看到您发布的实验被完成的情况
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="succerTest = false">知道了</el-button>
        </div>
      </span>
    </el-dialog>

    <!--解散班级-->
    <el-dialog
      title="解散班级"
      :visible.sync="classDismiss"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="width: 300px; margin: auto">
        您确定要解散班级吗？解散班级后班级内学生的数据会全部清空且无法找到！
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="classDismissF">确定解散</el-button>
          <br />
        </div>
      </span>
    </el-dialog>

    <!--毕业班级-->
    <el-dialog
      title="毕业班级"
      :visible.sync="classGraduation"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="width: 300px; margin: auto">
        您确定要毕业班级吗？毕业班级后班级内学生将取消vip权限并转入毕业班级区
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="classGraduationF">确定毕业</el-button>
          <br />
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import {
  getclassinfo,
  getclassuser,
  editclass,
  getClassExperimentMasteryInfo,
  pushexam,
  editUserMark,
  getexperextent,
  getpushlist,
  getClassExperimentStatistics,
  getuserinfo,
  revokepublic,
  delclass,
  graduation,
  getexpertestinfo,
  getexamlist,
  getclasslist,
} from "./../../api/exam_api";
export default {
  data() {
    let _minTime = null;
    let _maxTime = null;
    return {
      noClass: false,
      classUserNum: 0,
      succerTest: false,
      releaseUndo: false,
      tableData3: [],
      tableData4: [],
      filters: {
        pageSize: 2,
        total: 0,
        page: 1,
      }, // 正在进行的的页
      filters2: {
        pageSize: 2,
        total: 0,
        page: 1,
      }, // 已完成的页
      currentPage4: 1,
      releaseTest: false,
      releaseTest2: false,
      pickerOptions: {
        onPick(time) {
          // 如果选择了只选择了一个时间
          if (!time.maxDate) {
            var tempDate = new Date(time.minDate.getTime());
            _minTime = new Date(tempDate.setMonth(tempDate.getMonth() - 2)).getTime(); // 最小时间
            _maxTime = new Date(tempDate.setMonth(tempDate.getMonth() + 4)).getTime(); // 最大时间
          }
          // 如果选了两个时间，那就清空本次范围判断数据，以备重选
          else {
            _minTime = _maxTime = null;
          }
        },
        disabledDate(time) {
          // onPick后触发
          if (_minTime && _maxTime) {
            return time.getTime() < _minTime || time.getTime() > _maxTime;
          }
        },
      },

      classDismiss: false,
      classGraduation: false,
      groupId: "",
      succerTest: false,
      classUserNum: false,
      examUrl: "",
      chaildMsg: "123",
      joinGuide: false,
      editNoteLoading: false,
      editNoteDialog: false,
      markname: "",
      releaseLoading: false,
      classSelected: "",
      textNum: 0,
      releaseArray: [],
      releaseForm: {
        checkedTest: [],
        name: "",
        time: "",
        checkClass: [],
      },
      classInfo: {
        classname: "",
      },
      releaseUndo: false,
      SecondaryWidth: "",
      activeName: "class1",
      radio3: "日",
      chartData: {
        columns: ["counttime", "countnum"],
        rows: [],
      },
      chartSettings: {
        labelMap: {
          countnum: "平均分",
        },
      },
      tableData: [],
      studentList: [],
      studentNumber: 0,
      selectValue: "",
      timeValue: "",
      changeClass: true,
      oldClassName: "",
      classId: "",
      classData: [],
      testList: [],
      rulesRelease: {
        name: [
          {
            required: true,
            min: 2,
            max: 15,
            message: "请输入2到15位考试名称",
            trigger: "blur",
          },
        ],
        time: [{ required: true, message: "请选择起止时间", trigger: "blur" }],
        checkClass: [
          { required: true, message: "请选择班级", trigger: "blur" },
        ],
      },
      timeArrray: [],
      editStudentId: "",
    };
  },
  methods: {
    //毕业班级
    classGraduationF() {},
    //解散班级
    classDismissF() {
      delclass({ classId: this.classId, pid: this.GLOBAL.pid }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          location.reload();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //撤销
    //撤销
    relectUpdo(groupId, classId) {
      this.releaseUndo = true;
      this.groupId = groupId;
      this.classId = classId;
    },
    undoGroup() {
      revokepublic({ group_id: this.groupId, class_id: this.classId }).then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.releaseUndo = false;
            this.getList();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        }
      );
    },
    /* getChildData($id,$type) {
      getclasslist().then(res => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].class_id = res.data[i].class_id.toString();
          }
          this.classList = res.data;
        }
      });
    },*/
    pageSizeChange(val) {
      this.filters.pageSize = val;
      this.getList();
    }, // 正在进行
    pageChange(val) {
      this.filters.page = val;
      this.getList();
    }, // 正在进行

    pageSizeChange2(val) {
      this.filters2.pageSize = val;
      this.getList();
    }, // 已完成
    pageChange2(val) {
      this.filters2.page = val;
      this.getList();
    }, // 已完成

    getList() {
      let data1 = {
        page: this.filters.page,
        perPage: this.filters.pageSize,
        state: 1,
      };
      let data2 = {
        page: this.filters2.page,
        perPage: this.filters2.pageSize,
        state: 2,
      };
      // 获取正在进行的考试
      let that = this;
      getpushlist(data1).then((res) => {
        if (res.code == 0) {
          if (res.data != []) {
            this.tableData3 = res.data.data || [];
            for (let i = 0; i < this.tableData3.length; i++) {
              if (this.tableData3[i].examination_info) {
                this.tableData3[i].group_name =
                  this.tableData3[i].examination_info.name;
              } else {
                this.tableData3[i].group_name = "";
              }
              this.tableData3[i].classname = this.tableData3[i].class_info.name;
              this.tableData3[i].class_id = this.tableData3[i].classId;
            }
            this.filters.total = res.data.total;

            this.tableData3.forEach(function (index, i) {
              if (index.examination_info != null) {
                let _timeNow = new Date();
                index.start_time = that.GLOBAL.request.toTime(
                  index.examination_info.beginTime * 1000,
                  1
                );
                index.add_time = that.GLOBAL.request.toTime(
                  index.examination_info.addTime * 1000,
                  1
                );
                index.end_time = that.GLOBAL.request.toTime(
                  index.examination_info.endTime * 1000,
                  1
                );
              }

              if (index.examination_experiment[0]) {
                let oDate2 = index.examination_info.endTime * 1000;
                let oDate1 = new Date();
                let nTime = oDate2 - oDate1.getTime();
                let day = Math.floor(nTime / 86400000);
                let hour = Math.floor((nTime % 86400000) / 3600000);
                let minute = Math.floor(((nTime % 86400000) % 3600000) / 60000);
                let _time = day + "天 " + hour + "小时 " + minute + "分";
                index.endTime = _time;

                index.item = index.examination_experiment;
                for (let i = 0; i < index.item.length; i++) {
                  index.item[i].ratioHalf =
                    index.item[i].finishExam <= 0
                      ? 0
                      : Math.round(
                          (index.item[i].finishExam /
                            (index.item[i].unfinishExam +
                              index.item[i].finishExam)) *
                            10000
                        ) / 100.0;
                  index.item[i].studentNum =
                    index.item[i].unfinishExam + index.item[i].finishExam;
                  // index.item[i].studentNum = index.class_info.num;

                  index.item[i].sub_num = index.item[i].finishExam;

                  index.item[i].examination_id = index.examination_info.id;
                }
              }
            });
          }
        }
      });
      // 获取已经结束的考试
      getpushlist(data2).then((res) => {
        if (res.code == 0) {
          if (res.data != []) {
            this.tableData4 = res.data.data;
            for (let i = 0; i < this.tableData4.length; i++) {
              if (this.tableData4[i].examination_info) {
                this.tableData4[i].group_name =
                  this.tableData4[i].examination_info.name;
              } else {
                this.tableData4[i].group_name = "";
              }
              this.tableData4[i].classname = this.tableData4[i].class_info.name;
              this.tableData4[i].class_id = this.tableData4[i].classId;
            }
            this.filters2.total = res.data.total;

            this.tableData4.forEach(function (index, i) {
              if (index.examination_info != null) {
                index.start_time = that.GLOBAL.request.toTime(
                  index.examination_info.beginTime * 1000,
                  1
                );

                index.add_time = that.GLOBAL.request.toTime(
                  index.examination_info.addTime * 1000,
                  1
                );
                index.end_time = that.GLOBAL.request.toTime(
                  index.examination_info.endTime * 1000,
                  1
                );
              }

              if (index.examination_experiment[0]) {
                if (index.examination_experiment[0].finishExam == 0) {
                  let oDate2 = index.examination_info.endTime * 1000;
                  let oDate1 = new Date();
                  let nTime = oDate2 - oDate1.getTime();
                  let day = Math.floor(nTime / 86400000);
                  let hour = Math.floor((nTime % 86400000) / 3600000);
                  let minute = Math.floor(
                    ((nTime % 86400000) % 3600000) / 60000
                  );
                  let _time = day + "天 " + hour + "小时 " + minute + "分";
                  index.endTime = _time;
                }

                index.item = index.examination_experiment;

                for (let i = 0; i < index.item.length; i++) {
                  index.item[i].ratioHalf =
                    index.item[i].finishExam <= 0
                      ? 0
                      : Math.round(
                          (index.item[i].finishExam /
                            (index.item[i].unfinishExam +
                              index.item[i].finishExam)) *
                            10000
                        ) / 100.0;
                  index.item[i].studentNum =
                    index.item[i].unfinishExam + index.item[i].finishExam;

                  index.item[i].sub_num = index.item[i].finishExam;
                  index.item[i].examination_id = index.examination_info.id;
                }
              }
            });
          }
        }
      });

      getclasslist().then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].class_id = res.data[i].class_id.toString();
            res.data[i].isSelect = false;
          }
          this.classList = res.data;
        }
      });
    },
    backToClass(classId) {
      let cID = document.getElementById("classType");
      let cClass = document.getElementsByClassName("header-nav");
      for (let i = 0; i < cClass.length; i++) {
        cClass[i].classList.remove("activeNav");
      }
      cID.classList.add("activeNav");
      let _url = window.location.host;
      window.location.href = "/#/manageclass?backClass=1&plan=" + classId;
    },

    //实验列表
    examList($data, $type) {
      getexpertestinfo({ packageId: this.GLOBAL.productId }).then((res) => {
        if (res.code == 200) {
          this.testList = res.data;
          for (let i = 0; i < res.data.length; i++) {
            this.testList[i].experiment_id = res.data[i].relation_id;
          }
          if ($type != -2) {
            this.selectValue = "";
          }
        }
      });
    },

    //获取班级数据
    getChildData($data, allData, $type) {
      //获取班级信息
      this.loadingInstance = Loading.service({
        target: "#nbBody"
      });
      this.classId = $data;
      this.classData = allData;
      getclassinfo({ id: $data }).then((res) => {
        if (res.code == 0) {
          res.data[0].classname = res.data[0].name;
          res.data[0].addTime = this.GLOBAL.request.toTime(
            res.data[0].addTime * 1000,
            1
          );
          this.classInfo = res.data[0];
          this.classInfo.class_code = res.data[0].classCode;
          this.classInfo.addtime = res.data[0].addTime;
        }
      });
      this.getClassUserList($data);
      getClassExperimentMasteryInfo({ classId: $data }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.tableData = res.data;
          this.tableData.forEach((index, i) => {
            index.name = index.course.name;
            index.avgScore = index.avgScore.toFixed(1);
          });
        }
      });
      this.examList($data, $type);
      //班级统计
      let data = {
        classId: $data,
        experimentId: this.selectValue,
        startTime:
          this.timeValue && this.timeValue.length > 0 ? this.timeValue[0].getTime() / 1000 : "",
        endTime:
          this.timeValue && this.timeValue.length > 0 ? this.timeValue[1].getTime() / 1000 : "",
      };
      getClassExperimentStatistics(data).then((res) => {
        this.chartData.rows = [];
        if (res.code == 0 || res.code == 200) {
          let that = this;
          for (let i in res.data) {
            res.data[i].push_time = res.data[i].ymd;
            let obj = {
              counttime: that.GLOBAL.request.toTime(
                res.data[i].addtime * 1000,
                1
              ),
              countnum:
                res.data[i].num == 0 ? 0 : res.data[i].score / res.data[i].num,
            };
            that.chartData.rows.push(obj);
          }
        }
      });
    },

    //获取实验发布列表

    //获取班级用户
    getClassUserList($data) {
      getclassuser({ classId: $data }).then((res) => {
        if (res.code == 0) {
          this.studentList = res.data.data;
          this.studentNumber = res.data.total;
        }
        this.loadingInstance.close();
      });
    },
    //修改班级姓名
    clickClassName() {
      this.changeClass = false;
      this.oldClassName = Object.assign({}, this.classInfo.classname);
      let that = this;
      setTimeout(function () {
        let _name = document.getElementById("classNameInput");
        _name.focus();
      }, 10);
    },
    keyClassName(event) {
      if (event.keyCode == 13) {
        let _name = document.getElementById("classNameInput");
        _name.blur();
      }
    },
    //确定修改班级名称
    changeClassName() {
      if (
        this.oldClassName != this.classInfo.classname &&
        this.classInfo.classname &&
        this.classInfo.classname.length <= 10 &&
        this.classInfo.classname.length >= 2
      ) {
        editclass({
          id: this.classId,
          pid: this.GLOBAL.pid,
          name: this.classInfo.classname,
        }).then((res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$refs.tags.classListF();
            this.changeClass = true;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
            setTimeout(function () {
              let _name = document.getElementById("classNameInput");
              _name.focus();
            }, 10);
          }
        });
      } else {
        if (this.oldClassName == this.classInfo.classname) {
          this.changeClass = true;
        } else {
          this.$message({
            message: "班级名称应在2到10位",
            type: "error",
          });
          setTimeout(function () {
            let _name = document.getElementById("classNameInput");
            _name.focus();
          }, 10);
        }
      }
    },
    //发布实验下一步
    //确定发布实验
    //修改备注姓名
    editNote(studentId) {
      if (studentId != -1) {
        this.editStudentId = studentId;
      }
      if (this.editNoteDialog) {
        this.editNoteLoading = true;
        let data = {
          class_id: this.classId,
          id: this.editStudentId,
          markName: this.markname,
        };
        editUserMark(data).then((res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.editNoteDialog = false;
            this.markname = "";
            this.editNoteLoading = false;
            this.getClassUserList(this.classId);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
            this.editNoteLoading = false;
          }
        });
      } else {
        this.editNoteDialog = true;
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
.el-select .el-input i {
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ManageClass.vue